var FilteredProducts = (function ($, Navigation, Page, firstBy) {
    'use strict';
    
    var
        currentSort,
        currentCategoryId,
        categoryRootId,
        currentLabel,
        currentSearchName,
        filtersJson,
        searchedProductsIds = [],
        priceFilteredProductsIds = [],
        categoryFilteredProductsIds = [],
        labelFilteredProductsIds = [];
    
    var azSort = function (a, b) {
        var
            nameA = a.name.toLowerCase(),
            nameB = b.name.toLowerCase();
        
        if (nameA < nameB)
        {
            return -1;
        }
        if (nameA > nameB)
        {
            return 1;
        }
        
        return 0;
    };
    
    var popularSort = function (a, b) {
        return b.downloads - a.downloads;
    };
    
    var recentlyUpdatedSort = function (a, b) {
        return b.recently_updated - a.recently_updated;
    };
    
    var priceAscSort = function (a, b) {
        return a.price - b.price;
    };
    
    var priceDescSort = function (a, b) {
        return b.price - a.price;
    };
    
    var regularSort = function (a, b) {
        return filtersJson.regularSort.indexOf(a.id) < filtersJson.regularSort.indexOf(b.id) ? -1 : 1;
    };
    
    var firstPayableSort = function (a, b) {
        var
            isFreeA = +(a.price === 0),
            isFreeB = +(b.price === 0);
        
        return isFreeA - isFreeB;
    };
    
    return {
        setup: function (_filtersJson, categoryId, _categoryRootId, sort) {
            filtersJson = _filtersJson;
            categoryRootId = _categoryRootId;
            
            this.filterByCategoryId(categoryId);
            this.filterByName('');
            this.filterByPrice('', '');
            this.filterByLabel();
            this.sortBy(sort);
        },
        
        setCategoryRootId: function (_categoryRootId) {
            categoryRootId = _categoryRootId;
        },
        
        filterByName: function (name) {
            currentSearchName = name.toLowerCase();
            searchedProductsIds = [];
            
            $.each(filtersJson.products, function () {
                if (currentSearchName === '' || this.name.toLowerCase().startsWith(currentSearchName))
                {
                    searchedProductsIds.push(this.id);
                }
            });
        },
        
        filterByPrice: function (from, to) {
            if (!Number.isInteger(from))
            {
                from = 0;
            }
            
            if (!Number.isInteger(to))
            {
                to = 99999;
            }
            
            priceFilteredProductsIds = [];
            
            $.each(filtersJson.products, function () {
                if (this.price >= from && this.price <= to)
                {
                    priceFilteredProductsIds.push(this.id);
                }
            });
        },
        
        filterByCategoryId: function (categoryId) {
            currentCategoryId = categoryId;
            categoryFilteredProductsIds = [];
            
            $.each(filtersJson.products, function () {
                if (!categoryId || $.inArray(categoryId, this.categories) >= 0)
                {
                    categoryFilteredProductsIds.push(this.id);
                }
            });
        },
        
        filterByLabel: function () {
            labelFilteredProductsIds = [];
            $.each(filtersJson.products, function () {
                if (this.labels.includes('WHMCS V9.0') || currentSort !== 'whmcs-9-support')
                {
                    labelFilteredProductsIds.push(this.id);
                }
            });
        },
        
        sort: function () {
            this.sortBy(currentSort);
        },
        
        setupMetaTitlePrefix: function () {
            var titlePrefix = '';
            
            switch (currentSort)
            {
                case 'popular':
                    titlePrefix = 'Popular ';
                    break;
                default:
                    titlePrefix = '';
            }
            
            Page.setMetaTitlePrefix(titlePrefix);
        },
        
        getCurrentSortValue: function () {
            return currentSort;
        },
        
        sortBy: function (value) {
            currentSort = value;
            
            switch (value)
            {
                case 'az':
                    filtersJson.products.sort(azSort);
                    break;
                
                case 'whmcs-9-support':
                case 'popular':
                    if (categoryRootId === 5)
                    {
                        filtersJson.products.sort(firstBy(firstPayableSort).thenBy(popularSort).thenBy(azSort));
                    } else if (currentSearchName)
                    {
                        filtersJson.products.sort(regularSort);
                    } else
                    {
                        filtersJson.products.sort(firstBy(popularSort).thenBy(azSort));
                    }
                    break;
                
                case 'recently-updated':
                    filtersJson.products.sort(recentlyUpdatedSort);
                    break;
                
                case 'price-asc':
                    filtersJson.products.sort(priceAscSort);
                    break;
                
                case 'price-desc':
                    filtersJson.products.sort(priceDescSort);
                    break;
                
                
                default:
                    if (currentSearchName)
                    {
                        filtersJson.products.sort(regularSort);
                    } else
                    {
                        filtersJson.products.sort(firstBy(popularSort).thenBy(azSort));
                    }
            }
            
            this.filterByLabel();
            //this.finish();
        },
        
        getFilteredProducts: function () {
            var products = [];
            
            $.each(filtersJson.products, function () {
                var
                    a = $.inArray(this.id, priceFilteredProductsIds) >= 0,
                    b = $.inArray(this.id, searchedProductsIds) >= 0,
                    c = $.inArray(this.id, categoryFilteredProductsIds) >= 0,
                    d = $.inArray(this.id, labelFilteredProductsIds) >= 0;
                
                if (a && b && c && d)
                {
                    products.push(this);
                }
            });
            
            return products;
        },
        
        getCountableFilteredProducts: function () {
            var products = [];
            
            $.each(filtersJson.products, function () {
                var
                    a = $.inArray(this.id, priceFilteredProductsIds) >= 0,
                    b = $.inArray(this.id, searchedProductsIds) >= 0,
                    d = $.inArray(this.id, labelFilteredProductsIds) >= 0;
                
                if (a && b && d)
                {
                    products.push(this);
                }
            });
            
            return products;
        },
        
        finish: function () {
            Page.preload();
            
            var
                $filtersPlaceholder = $('#sidebar-categories-navigation'),
                products = this.getFilteredProducts(),
                countableProducts = this.getCountableFilteredProducts(),
                allProductsCount = 0;
            
            $filtersPlaceholder.find('.category-anchor').each(function () {
                var
                    node = Navigation.makeFromAnchor(this),
                    $countBadge = node.getAnchor().find('.category-products-count'),
                    filteredCounts = 0;
                
                $.each(countableProducts, function () {
                    if ($.inArray(node.getCategoryId(), this.categories) >= 0)
                    {
                        filteredCounts++;
                    }
                });
                
                if (node.isRoot())
                {
                    allProductsCount += filteredCounts;
                }
                
                node.get().toggleClass('no-filtered-products-count', !filteredCounts);
                $countBadge.text(filteredCounts);
            });
            
            $filtersPlaceholder.find('.category-home').toggleClass('no-filtered-products-count', !allProductsCount);
            $filtersPlaceholder.find('.home-platform-products-count').text(allProductsCount);
            
            var productsHtml = products.map(function (product) {
                return product.html;
            });
            
            var
                $categoryProducts = $('#category-products').find('> .row'),
                $noResults = $('#category-no-products');
            
            setTimeout(function () {
                $categoryProducts.empty().html(productsHtml.join(''));
                
                $(document).trigger('products-recalculated', [products.length]);
                
                if (products.length)
                {
                    $noResults.addClass('hidden');
                } else
                {
                    $noResults.removeClass('hidden');
                }
                
                Page.finishLoad();
            }, 250);
        }
    };
    
})(jQuery, Navigation, Page, firstBy);
